import { v4 } from 'uuid';
import { MicrositeTemplate } from '~/model';
import type { PuckContent } from '~/editor/config';

export const PUCK_TEMPLATE_ALPHA: PuckContent = [
	{
		type: 'Hero',
		props: {
			id: v4(),
			template: MicrositeTemplate.ALPHA,
		},
	},
	{
		type: 'Matterport',
		props: {
			id: v4(),
			template: MicrositeTemplate.ALPHA,
		},
	},
	{
		type: 'Gallery',
		props: {
			id: v4(),
			template: MicrositeTemplate.ALPHA,
		},
	},
];
